module.exports = __webpack_public_path__ + "static/img/question.bc75a448.svg";